<template>
  <div>
    <landing-create :content="excelHeaderContent"></landing-create>
    <div class="centered">
      <v-select
      :items="converterList"
      label="Select Converter"
      item-text="name"
      item-value="code"
      outlined
      v-model="selectedConverter"
      return-object
    ></v-select>
      <v-card v-if='selectedConverter.code === "cgl"'>
        <Loader :isLoading="isLoading" />
        <v-card-title>
          <h2 class="title">CGL Header and Data Converter</h2>
        </v-card-title>
        <v-card-text>
          <v-file-input
            v-model="file"
            label="Upload your excel file here"
            prepend-icon="mdi-file-swap"
            class="fileInput"
            type="file"
            outlined
            multiple
            accept=".xlsx"
            @change="onFileChange"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" @click="proceedImport()">
            Convert
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if='selectedConverter.code === "ppmf"'>
        <v-card-title>
          <h2 class="title">PPMF Header and Data Converter</h2>
        </v-card-title>
        <v-card-text>
          <v-file-input
            v-model="file"
            label="Upload your excel file here"
            prepend-icon="mdi-file-swap"
            class="fileInput"
            type="file"
            outlined
            multiple
            accept=".xlsx"
            @change="onFileChange"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" @click="proceedImport()">
            Convert
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if='selectedConverter.code === "dscf"'>
        <Loader :isLoading="isLoading" />
        <v-card-title>
          <h2 class="title">DSCF Header and Data Converter</h2>
        </v-card-title>
        <v-card-text>
          <v-file-input
            v-model="file"
            label="Upload your excel file here"
            prepend-icon="mdi-file-swap"
            class="fileInput"
            type="file"
            outlined
            multiple
            accept=".xlsx"
            @change="onFileChange"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" @click="proceedImport()">
            Convert
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
 </div>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import services from '../../../services';
import Loader from '../../../components/utilities/Loader.vue';

const { controlPanelRegistry } = services;
const { excelConverterService } = controlPanelRegistry;
export default {
  name: 'ExcelConverterList',
  data: () => ({
    file: null,
    isLoading: false,
    converterList: [
      {
        code: 'cgl',
        name: 'CGL',
      },
      {
        code: 'ppmf',
        name: 'PPMF',
      },
      {
        code: 'dscf',
        name: 'DSCF',
      },
    ],
    selectedConverter: {},
    excelHeaderContent: {
      pageTitle: 'Data Converter',
    },
  }),
  components: {
    Loader,
    LandingCreate,
  },
  methods: {
    onFileChange(event) {
      this.file = event;
    },
    async proceedImport() {
      this.isLoading = true;
      const formData = new FormData();
      this.file.forEach((file) => {
        formData.append('attachments', file);
      });
      const { data, filename } = await excelConverterService.upload({ formData });
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');

      if (data) {
        setTimeout(() => {
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          if (link) {
            this.isLoading = false;
            // this.$router.go(0);
            this.$snackbar.show({
              text: 'Successfully converted',
              closeColor: 'white',
              color: 'green',
            });
          }
        }, 2000);
      }
    },
  },
  watch: {
    selectedConverter(newValue) {
      console.log('Selected item:', newValue);
      // Access selected item's properties like newValue.code or newValue.name
    },
  },
};
</script>

<style scoped>
.centered {
  margin: auto;
  width: 50%;
  padding: 10px;
}
.title {
  text-align: center;
  /* You can add more styles here */
}
</style>
